export default __webpack_public_path__ + "6fba080c0462165b76ea91d972c08046.svg";